export default "__VITE_ASSET__e7a22ab2__"